export function handleError(error: any) {
  const errorMessage = error.response ? error.response.data.errors : { message: "connection error", name: "" };
  return Promise.reject(errorMessage);
}
